import React from 'react'
import { Container, Row, Col, InputGroup, Form } from "react-bootstrap";
import shipping from "../../../assets/images/shipping.svg";
import variety from "../../../assets/images/variety.svg";
import warranty from "../../../assets/images/warranty.svg";
import crafted from "../../../assets/images/crafted.svg";
import logo from "../../../assets/images/footer-logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import "./footer.css"

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <Container>
                    <Row className="mb-4">
                        <Col lg={7}>
                            <div className="footer-content">
                                <h2 className='h2'>BE THE FIRST TO KNOW IT ALL!</h2>
                                <p>
                                    Never miss anything from shafaq waqas by signing up to our
                                    newsletter.
                                </p>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <InputGroup className="mb-3">
                                <Form.Control
                                    placeholder="Enter email address"
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                />
                                <div className="submit-form"></div>
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row className="mb-5">
                        <Col lg={12}>
                            <div className="shipping-box">
                                <Row>
                                    <Col lg={3}>
                                        <div className="shipping-wrapper d-flex align-items-center">
                                            <div className="shipping-img me-3">
                                                <img
                                                    className="img-fluid"
                                                    src={shipping}
                                                    alt="shipping"
                                                />
                                            </div>
                                            <div className="shipping-content">
                                                <strong>Shipping Charges</strong>
                                                <p>Starting from Rs. 120</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div className="shipping-wrapper d-flex align-items-center">
                                            <div className="shipping-img me-3">
                                                <img
                                                    className="img-fluid"
                                                    src={crafted}
                                                    alt="crafted"
                                                />
                                            </div>
                                            <div className="shipping-content">
                                                <strong>Crafted With Care</strong>
                                                <p>Curated with you in mind.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div className="shipping-wrapper d-flex align-items-center">
                                            <div className="shipping-img me-3">
                                                <img
                                                    className="img-fluid"
                                                    src={variety}
                                                    alt="variety"
                                                />
                                            </div>
                                            <div className="shipping-content">
                                                <strong>Variety</strong>
                                                <p>100+ designs and style</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div className="shipping-wrapper d-flex align-items-center">
                                            <div className="shipping-img me-3">
                                                <img
                                                    className="img-fluid"
                                                    src={warranty}
                                                    alt="warranty"
                                                />
                                            </div>
                                            <div className="shipping-content">
                                                <strong>Grantee</strong>
                                                <p>We are responsible for quality</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={3}>
                            <div className="footer-logo">
                                <img className="img-fluid" src={logo} alt="footer-logo" />
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="wrap-footer-links">
                                <h3>Useful Links</h3>
                                <ul className="p-0">
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Lahanga choli{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Bridals
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Doppatas
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Maxi
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Gharara/Shara
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="wrap-footer-links">
                                <h3>Quick Links</h3>
                                <ul className="p-0">
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Contact Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Terms & Conditions
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            Mission Statements
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="/">
                                            {" "}
                                            World Wide Shipping
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="wrap-footer-links">
                                <h3>Subscribe for Newsletter</h3>
                                <ul className="p-0">
                                    <li>
                                        <a
                                            className="footer-navlink"
                                            href="mailto:sales@shafaqwaqas.com"
                                        >
                                            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
                                            sales@shafaqwaqas.com
                                        </a>
                                    </li>
                                    <li>
                                        <a className="footer-navlink" href="+92 345 4037778">
                                            <FontAwesomeIcon className="me-2" icon={faWhatsapp} />
                                            +92 345 4037778
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="social-links-content">
                                <h3>Social Contact</h3>
                            </div>


                        </Col>
                    </Row>
                </Container>
            </footer>
            <div className="copyright-text">
                <p>© 2024 (shafaq waqas). All Rights Reserved</p>
            </div>
        </>
    )
}

export default Footer